
export type BannerDetailProps = {
  Culture: string;
};

export const BannerTitleConstants: { [key: string]: { title: string; placeholder: string } } = {
	"tr-TR": {
		title: "Başlık",
		placeholder: "İşin Geleceği, Geleceğin İşi"
	},
	"en-US": {
		title: "Title",
		placeholder: "The Future of Work, The Work of the Future"
	}
};

export const BannerBodyConstants: { [key: string]: { body: string; placeholder: string } } = {
	"tr-TR": {
		body: "Gövde",
		placeholder: "Daha çevik, daha esnek, daha yaratıcı, daha özgür… Geleceğin işiyle tanışın"
	},
	"en-US": {
		body: "Body",
		placeholder: "More agile, more flexible, more creative, more free... Meet the work of the future"
	}
};

export const BannerUrlConstants: { [key: string]: { url: string; placeholder: string } } = {
	"tr-TR": {
		url: "URL",
		placeholder: "https://www.kockariyerim.com"
	},
	"en-US": {
		url: "URL",
		placeholder: "https://www.kockariyerim.com"
	}
};